module.exports = __webpack_public_path__ + "img/Cherry.ff8ab3da.svg";